<template>
  <div class="home">
        <section>
          <div class="py-8 px-8">
            <div class="d-flexflex-wrapalign-items-centerjustify-content-between">
              <div class="col-12 col-lg-auto mb-4 mb-lg-0">
                <div class="d-flex align-items-center">
                </div>
              </div>
                  <div class="row">
                  <div class="col-sm-9">
                    <h4 class="mb-0 me-2">{{ $t("analytics") }}</h4>
                  </div>
                  <div class="col-sm-3" style="text-align:right">
                    <div class="mb-3">
                        <select v-model="duration" class="form-select bg-white small" aria-label="Select example">
                            <option value="last_7days">{{$t('last_7days')}}</option>
                            <option value="last_month">{{$t('last_month')}}</option>
                            <option value="last_3months">{{$t('last_3months')}}</option>
                            <option value="last_6months">{{$t('last_6months')}}</option>
                        </select>
                    </div>
                  </div>
                </div>

            </div>
          </div>
        </section>

      <section class="px-8">

        <div class="row">

          <div class="col-md-2">
                <div class="card mb-4 p-0 p-0">
                  <div class="card-header">
                    {{$t('total_revenue')}}
                  </div>
                  <div class="card-body">
                    <p v-if="total_revenue != null">{{ formatMoney(total_revenue) }}</p>
                    <p v-else>Loading...</p>
                  </div>
                </div>
          </div>

          <div class="col-sm-3">
                <div class="card mb-4 p-0">
                  <div class="card-header">
                    {{$t('avg_revenue_per_customer')}}
                  </div>
                  <div class="card-body">
                    <p v-if="avg_revenue_per_customer != null">{{ avg_revenue_per_customer }}</p>
                    <p v-else>Loading...</p>
                  </div>
                </div>
          </div>
                
          <div class="col-sm-2">
                <div class="card mb-4 p-0">
                  <div class="card-header">
                   {{$t('number_of_customers')}}
                  </div>
                  <div class="card-body">
                    <p v-if="number_customer != null">{{ number_customer }}</p>
                    <p v-else>Loading...</p>
                  </div>
                </div>
          </div>

          <div class="col-sm-3">
              <div class="card mb-4 p-0">
                <div class="card-header">
                 {{$t('avg_revenue_per_order')}}
                </div>
                <div class="card-body">
                  <p v-if="avg_revenue_order != null">{{ formatMoney(avg_revenue_order) }} </p>
                  <p v-else>Loading...</p>
                </div>
              </div>
          </div>

          <div class="col-sm-2">
                <div class="card mb-4 p-0">
                  <div class="card-header">
                    {{$t('number_of_orders')}}
                  </div>
                  <div class="card-body">
                    <p v-if="number_order != null">{{ number_order }}</p>
                    <p v-else>Loading...</p>
                  </div>
                </div>
          </div>

          <div class="col-sm-4">
            <div class="card mb-4 p-0">
              <div class="card-header">
                {{$t('revenue_trend_over_time')}}
              </div>
              <div class="card-body">
                <p>
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">{{$t('order_date')}}</th>
                        <th scope="col">{{$t('monthly_revenue')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in revenue_trend_over_time" :key="index">
                        <td>{{ item.order_date }}</td>
                        <td>{{ formatMoney(item.daily_revenue) }}</td>
                      </tr>
                    </tbody>
                  </table>

                  </p>
              </div>
            </div>
          </div>
      
          <div class="col-sm-4">
              <div class="card mb-4 p-0">
                <div class="card-header">
                  {{$t('top_customers')}}
                </div>
                <div class="card-body">
                  <p v-if="top_customers">
                    <table class="table">
              <thead>
                <tr>
                  <th scope="col">{{$t('id')}}</th>
                  <th scope="col">{{$t('name')}}</th>
                  <th scope="col">{{$t('total_revenue')}}</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="(item,index) in  top_customers" :key="index">
                  <td>{{ item.id }}</td>
                  <td>{{ item.name }}</td>
                  <td>{{ formatMoney(item.total_revenue) }}</td>
                </tr>
              </tbody>
            </table>

                  </p>
                  <p v-else>Loading...</p>
                </div>
              </div>
          </div>

          <div class="col-sm-4">  
            <div class="card mb-0 p-0">
          <div class="card-header">
            {{$t('monthly_revenue')}}
          </div>
          <div class="card-body">
            <p v-if="monthly_revenue">
              <table class="table">
        <thead>
          <tr>
            <th scope="col">{{$t('year')}}</th>
            <th scope="col">{{$t('month')}}</th>
            <th scope="col">{{$t('monthly_revenue')}}</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(item,index) in  monthly_revenue" :key="index">
            <td>{{ item.year }}</td>
            <td>{{ item.month }}</td>
            <td>{{ formatMoney(item.monthly_revenue) }} </td>
          </tr>
        </tbody>
      </table>

            </p>
            <p v-else>Loading...</p>
          </div>
              </div>
          </div>

          <div class="col-sm-4">
            <div class="card mb-4 p-0">
              <div class="card-header">
                {{$t('inventory_insights')}}
              </div>
              <div class="card-body">
                <p v-if="inventory_insights">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">{{$t('total_products')}}</th>
                        <th scope="col">{{$t('out_of_stock_products')}}</th>
                        <th scope="col">{{$t('low_stock_products')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ inventory_insights.totalProducts }}</td>
                        <td>{{ inventory_insights.outOfStockProducts }}</td>
                        <td>{{ inventory_insights.lowStockProducts }}</td>
                      </tr>
                    </tbody>
                  </table>
                </p>
                <table-loading-bar v-else />
              </div>
            </div>
          </div>

          <div class="col-sm-4">
            <div class="card mb-4 p-0">
              <div class="card-header">
                {{$t('sales_insights')}}
              </div>
              <div class="card-body">
                <p v-if="sales_insights">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">{{$t('total_sales')}}</th>
                        <th scope="col">{{$t('total_revenue')}}</th>
                        <th scope="col">{{$t('total_expenses')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td>{{ sales_insights.totalSales }}</td>
                        <td>{{ sales_insights.totalRevenue }}</td>
                        <td>{{ sales_insights.totalExpenses }}</td>
                      </tr>
                    </tbody>
                  </table>
                </p>
                <table-loading-bar v-else />
              </div>
            </div>
          </div>

          <div class="col-sm-12">
            <div class="card mb-4 p-0">
              <div class="card-header">
                {{$t('top_selling_products')}}
              </div>
              <div class="card-body">
                <p v-if="top_selling_products">
                  <table class="table">
                    <thead>
                      <tr>
                        <th scope="col">{{$t('product_label')}}</th>
                        <th scope="col">{{$t('total_sold')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr v-for="(item,index) in  top_selling_products" :key="index">
                        <td>{{ item.product_label }}</td>
                        <td>{{ item.total_sold }}</td>
                      </tr>
                    </tbody>
                  </table>

                </p>
                <table-loading-bar v-else />
              </div>
            </div>
          </div>
  
  </div>

      </section>
  </div>
</template>

<script>
import helper from '../helper'
// import DatePicker from 'vue2-datepicker';
import moment from 'moment'
export default {
  name: "Analytics",
  // components : {DatePicker},
  data() {
    return {
        total : 0,
        range : [],
        duration : 'last_3months',
        total_revenue: null,
        avg_revenue_per_customer: null,
        number_customer: null,
        avg_revenue_order: null,
        number_order: null,
        revenue_trend_over_time: null,
        top_customers: null,
        monthly_revenue: null,
        customer_lifetime_value: null,
        top_selling_products : null,
        inventory_insights: null,
        sales_insights: null,
        start : moment().subtract(3,'month').format('YYYY-MM-DD'),
        end : null,
    };
  },
  async mounted(){
    window.mixpanel.track("analytics");

    this.getAnalytics()
    this.getInventoryInsights();
    this.getSalesInsights();

  },
  methods : {
    formatMoney(number) { return helper.formatMoney(number);},
    async fetchAnalytics(type) {
      const {data} = await helper.customGet(`${process.env.VUE_APP_API}/v2/analytics?type=${type}&end=${this.end}&start=${this.start}`)
      return data
    },
    async fetchInsights(type) {
      const {data} = await helper.customGet(`${process.env.VUE_APP_API}/v2/insights?type=${type}&end=${this.end}&start=${this.start}`)
      return data
    },
    getAnalytics(){

        this.fetchAnalytics('total-revenue').then(response => { 
          this.total_revenue = response.data.total_revenue != null ? response.data.total_revenue : 0
        })
        this.fetchAnalytics('avg-revenue-customer').then(response => {
          this.avg_revenue_per_customer = response.data.avg_revenue_per_customer != null ? response.data.avg_revenue_per_customer : 0
        })
        this.fetchAnalytics('number-customer').then(response => {
          this.number_customer = response.data.number_customers != null ? response.data.number_customers : 0
        })
        this.fetchAnalytics('avg-revenue-order').then(response => {
          this.avg_revenue_order = response.data.avg_revenue_per_order != null ? parseInt(response.data.avg_revenue_per_order) : 0
        })
        this.fetchAnalytics('number-order').then(response => {this.number_order = response.data.number_orders})
        this.fetchAnalytics('revenue-trend-over-time').then(response => {this.revenue_trend_over_time = response.data})
        this.fetchAnalytics('top-customers').then(response => {this.top_customers = response.data})
        this.fetchAnalytics('monthly-revenue').then(response => {this.monthly_revenue = response.data})
        this.fetchAnalytics('top-selling-products').then(response => {this.top_selling_products = response.data})
    },
    getInventoryInsights(){
      this.fetchAnalytics('inventory').then(response => { 
        this.inventory_insights = response
      })
    },
    getSalesInsights(){
      this.fetchAnalytics('sales').then(response => { 
        this.sales_insights = response
      })
    }
  },
  computed : {
    business(){
      return this.$store.getters.BUSINESS
    }
  },
  watch : {
    range(){
        if(this.range[0] == null){
            this.start = moment().subtract(1,'year').format('YYYY-MM-DD')
            this.start_date = this.start
            this.end = moment().format('YYYY-MM-DD')
            this.end_date = this.end
            this.getAnalytics()
        }else if(this.range.length && this.range[0] && this.range[1]){
            this.start = moment(this.range[0]).format('YYYY-MM-DD')
            this.end = moment(this.range[1]).format('YYYY-MM-DD')
            this.getAnalytics()
        }
    },
    duration(){
      if(this.duration == 'last_7days'){
        this.start = moment().subtract(7,'days').format('YYYY-MM-DD')
        this.end = moment().format('YYYY-MM-DD')
      }else if(this.duration == 'last_month'){
        this.start = moment().subtract(1,'month').format('YYYY-MM-DD')
        this.end = moment().format('YYYY-MM-DD')
      }else if(this.duration == 'last_3months'){
        this.start = moment().subtract(3,'month').format('YYYY-MM-DD')
        this.end = moment().format('YYYY-MM-DD')
      }else if(this.duration == 'last_6months'){
        this.start = moment().subtract(6,'month').format('YYYY-MM-DD')
        this.end = moment().format('YYYY-MM-DD')
      }

      this.getAnalytics()
    }
  }
};
</script>
